module.exports = __webpack_public_path__ + "img/Aura_mystic.2e0ce646.png";